import format from '@/mixins/helpers'
const processOrderProducts = (headers, list, payload, transData, settings, includeLocation, withPrices) => {
  let getHeaders = ''
  let getContent = ''
  let currency = ''
  let getTotalValue = 0
  headers = includeLocation ? headers : headers.filter(x => x.value !== 'location')
  headers = withPrices ? headers : headers.filter(x => x.value !== 'price' && x.value !== 'total')
  headers = withPrices && list && list.some(x => x.discount) ? headers : headers.filter(x => x.value !== 'discount' && x.value !== 'discounted')
  for (let i = 0; i < headers.length; i++) {
    if (headers[i].value === 'qty' || headers[i].value === 'price' || headers[i].value === 'discount' || headers[i].value === 'discounted' || headers[i].value === 'total') getHeaders += `<th class="th-fontsize text-right" width="${headers[i].width}">${headers[i].text}</th>`
    else getHeaders += `<th class="th-fontsize" width="${headers[i].width}">${headers[i].text}</th>`
  }
  for (let j = 0; j < list.length; j++) {
    currency = list[j].currency
    getContent += `<tr>
      <td>${list[j].productnumber || ''}</td>
      <td>${list[j].producttext || ''}</td>`
    if (includeLocation) {
      getContent += `<td>`
      if (list[j].receivedlocations && list[j].receivedlocations.length > 0) {
        list[j].receivedlocations.map((x, index) => {
          getContent += x.locationname
          if (index !== (list[j].receivedlocations.length - 1)) {
            getContent += `<br />`
          }
        })
      } else if (list[j].locationsview) {
        list[j].locationsview.map((x, index) => {
          getContent += x.name
          if (index !== (list[j].locationsview.length - 1)) {
            getContent += `<br />`
          }
        })
      }

      getContent += `</td>`
    }
    getContent += `<td class="text-right">${format.methods.$_replaceDotWithCommaIfHasDecimal(list[j].qty)}</td>
      <td>${list[j].unitname || ''}</td>`
    if (withPrices) {
      const discountCols = list && list.some(x => x.discount) ? `<td class="text-right">${format.methods.$_replaceDotWithComma(list[j].discount)}</td>
      <td class="text-right">${format.methods.$_replaceDotWithComma(list[j].discounted)}</td>` : ''

      getContent += `<td class="text-right">${format.methods.$_replaceDotWithComma(list[j].discountedprice)}</td>
        ${discountCols}
      <td class="text-right">${format.methods.$_replaceDotWithComma(list[j].totalprice)}</td>`
    }
    getContent += `</tr>`

    if (list[j].comments) {
      getContent += `
      <tr>
        <td style="border: none"></td>
        <td style="border: none"><span>${list[j].comments || ''}</span></td>
      </tr>`
    }

    getTotalValue += list[j].totalprice
  }
  getTotalValue = format.methods.$_replaceDotWithComma(getTotalValue)
  return content(getHeaders, getContent, payload, transData, getTotalValue, settings, currency, withPrices)
}
const content = (headers, content, payload, transData, getTotalValue, settings, currency, withPrices) => btoa(unescape(encodeURIComponent(`<!DOCTYPE html>
<html>
  <head>
    <meta content="text/html; charset=utf-8" http-equiv="Content-Type"/>
    <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.4.1/css/bootstrap.min.css">
    <style>
    body {
      font-family: "Helvetica Neue",Helvetica,Arial,sans-serif;
      letter-spacing: 0.5px !important;
      font-size: 16px !important;
    }
    .footer {
      position: fixed;
      left: 0;
      bottom: 0;
      width: 100%;
      text-align: center;
    }
    tbody tr { page-break-inside:avoid; }
    tbody tr td { word-break: break-word; }
    .table-condensed>tbody>tr>td, .table-condensed>tbody>tr>th, .table-condensed>tfoot>tr>td, .table-condensed>tfoot>tr>th, .table-condensed>thead>tr>td, .table-condensed>thead>tr>th {
      padding: 2.5px !important;
    }
    </style>
  </head>
  <body>
  <div class="container-fluid">
  <div class="row">
    <div class="col-xs-5">
      <b>${transData.supplier}:</b><br>
      <p style="margin: 0">${payload.supplier_name || ''}</p>
      <p style="margin: 0">${payload.supplier_address || ''}</p>
      <p style="margin: 0">${payload.supplier_address2 || ''}</p>
      <p style="margin: 0">${payload.supplier_postcode || ''} ${payload.supplier_city || ''} ${payload.supplier_country || ''}</p>
    </div>
    <div class="col-xs-4">
        <span>Kilab AS, 912195759</span><br>
        <span>Majorvegen 22, 2030 Nannestad</span><br>
        <span>firmapost@kilab.no &nbsp &nbsp &nbsp www.kilab.no</span><br><br>
    </div>
    <div class="col-xs-3">
      <img class="img-responsive pull-right" height="180" width="180" src="https://kilabapi.apphouse.no/kilab_logo.png" alt="kilab">
    </div>
    <div class="col-xs-12"></div>
    <div class="col-xs-6" style="margin-top: 15px;">
      <b>${transData.deliveryAddress}:</b><br>
      ${payload.deliverto ? `<p style="margin: 0">${payload.deliverto_name || ''}</p>
        <p style="margin: 0">${payload.customer_address || ''}</p>
        <p style="margin: 0">${payload.customer_address2 || ''}</p>
        <p style="margin: 0">${payload.customer_postcode || ''} ${payload.customer_city || ''} ${payload.customer_country || ''}</p>`
    : `<span style="white-space: pre-wrap;">${settings.post_address || ''}</span>`}
    </div>

    <div class="col-xs-6">
      <table style="width: 100%">
        <tr>
          <td width="50%"><h4>${transData.order}:</h4></td>
          <td width="50%" class="text-right"><h4>${payload.number || ''}</h4></td>
        </tr>
      </table>
      <hr style="margin: 1px;" />
      <table style="width: 100%">
          <tr>
            <td width="50%">${transData.date}:</th>
            <td width="50%" class="text-right">${payload.orderdate || ''}</td>
          </tr>
          <tr>
            <td width="50%">${transData.requestedDate}:</td>
            <td width="50%" class="text-right">${payload.estimated_date || ''}</td>
          </tr>
          ${payload.salesreference ? `<tr>
              <td width="50%">${transData.kilabOrder}:</td>
                <td width="50%" class="text-right">${payload.salesreference}</td>
          </tr>` : ''}
          <tr>
            <td width="50%">${transData.ourContact}:</td>
            <td width="50%" class="text-right">${payload.responsible_name ? payload.responsible_name : ''}</td>
          </tr>
          <tr>
            <td width="50%">${transData.contact}:</td>
            <td width="50%" class="text-right">${payload.suppliercontactname || ''}</td>
          </tr>
          <tr>
            <td width="50%">${transData.labeled}:</td>
            <td width="50%" class="text-right">${payload.labeled || ''}</td>
          </tr>
        </table>
    </div>
  </div>

    <div class="row">
      <div class="col-xs-12 mt-2">
        <table style="width: 100%">
          <tr>
            <th width="90%">${transData.comments}:</th>
          </tr>
          <tr>
            <td width="90%">${payload.comments || ''}</td>
          </tr>
        </table>
      </div>
      <div class="col-xs-12" style="margin-top: 4px;">
        <table class="table table-condensed" style="width: 100%">
          <tbody>
            <tr>
              ${headers}
            </tr>
            ${content}
          </tbody>
        </table>
      </div>
      <div class="col-xs-6"></div>
      ${withPrices ? `<div class="col-xs-6">
        <table style="width: 75%" class="pull-right">
        <tr>
            <th colspan="2">
              <hr style="margin: 4px" />
            </th>
          </tr>
          <tr>
            <td width="75%">${transData.total} (${currency || ''}):</td>
            <td width="25%" class="text-right">${getTotalValue}</td>
          </tr>
        </table>
      </div>` : ''}
    </div>
  </div>
</body>
</html>`)))
export default processOrderProducts
